// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'
import { isBrowser, isTablet } from 'react-device-detect'
import { Button } from '@lmc/ui-kit'

const isDesktop = isBrowser || isTablet

const FormFooter = (props) => {
  const {
    onConfirm,
    confirmLabel,
    cancelLabel,
    onCancel,
    onDelete,
    deleteLabel,
    isSubmitting,
    containerStyles,
  } = props

  return (
    <div
      className="lmc-fixed-footer"
      style={{ ...styles.footer, ...containerStyles }}
    >
      <div>
        {onDelete && (
          <Button
            id="delete-button"
            onClick={onDelete}
            style={styles.deleteButton}
            variant="danger"
          >
            {deleteLabel}
          </Button>
        )}
      </div>
      <div style={styles.buttonContainer}>
        {onCancel && (
          <Button id="cancel-button" onClick={onCancel} variant="default">
            {cancelLabel}
          </Button>
        )}
        {onConfirm && (
          <Button
            id="edit-button"
            onClick={onConfirm}
            style={styles.editButton}
            variant="primary"
            loading={isSubmitting}
          >
            {confirmLabel}
          </Button>
        )}
      </div>
    </div>
  )
}

FormFooter.propTypes = {
  cancelLabel: PropTypes.string,
  deleteLabel: PropTypes.string,
  editLabel: PropTypes.string,
  onCancel: PropTypes.func,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  containerStyles: PropTypes.func,
}

const styles = {
  footer: {
    marginTop: 35,
    width: isBrowser || isTablet ? 'calc(100vw - 290px)' : '100vw',
  },
  buttonContainer: { display: 'flex', flexDirection: 'row', gap: 8 },
  deleteButton: {
  },
  editButton: {
    paddingLeft: 8,
  },
  cancelButton: {
    marginRight: 10,
    padding: '0px 25px',
    textShadow: 'none',
  },
}

export default FormFooter
